import { render, staticRenderFns } from "./MajorsApp.vue?vue&type=template&id=de2e4e62&scoped=true"
import script from "./MajorsApp.vue?vue&type=script&lang=js"
export * from "./MajorsApp.vue?vue&type=script&lang=js"
import style0 from "./MajorsApp.vue?vue&type=style&index=0&id=de2e4e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2e4e62",
  null
  
)

export default component.exports